(function($) {

    window.onscroll = function() {
        stickyHeader()
    };

    var siteHeader = document.getElementById('siteHeader');
    var siteContent = document.getElementById('mainContent');
    var sticky = siteHeader.offsetTop;
    var siteHeaderHeight = $('.site-header').outerHeight();

    function stickyHeader() {
        if (window.pageYOffset > sticky) {
            $(siteHeader).addClass('is-sticky');

            $(siteContent).css('padding-top', siteHeaderHeight + 'px');

        } else {
            $(siteHeader).removeClass('is-sticky');
            $(siteContent).css('padding-top', 0);
        }
    }

    /*Primary dropdown close button*/
    $('.js-close-dropdown').on('click', function() {
        $('.dropdown-toggle').dropdown();
    });

    const $dropdown = $(".dropdown:not(.dropdown-search)");
    const $dropdownToggle = $(".dropdown-toggle");
    const $dropdownMenu = $(".dropdown-menu");
    const showClass = "show";
    
    $(window).on("load resize", function() {
    if (this.matchMedia("(min-width: 992px)").matches) {
        $dropdown.hover(
        function() {
            const $this = $(this);
            $this.addClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "true");
            $this.find($dropdownMenu).addClass(showClass);
        },
        function() {
            const $this = $(this);
            $this.removeClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "false");
            $this.find($dropdownMenu).removeClass(showClass);
        }
        );
    } else {
        $dropdown.off("mouseenter mouseleave");
    }
    });

}(jQuery));